import type { IconProps } from './types';

export const PlusIcon = (props: IconProps) => {
  const {
    size = 16,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.25027 14.8567V8.70438H1.14285C0.728686 8.70438 0.392929 8.36853 0.392853 7.95438C0.392853 7.54017 0.728639 7.20438 1.14285 7.20438H7.25027V1.14286C7.25027 0.728644 7.58606 0.392857 8.00027 0.392857C8.41436 0.393008 8.75027 0.728736 8.75027 1.14286V7.20438H14.8567L14.9339 7.20829C15.312 7.24672 15.6067 7.56608 15.6067 7.95438C15.6066 8.34263 15.312 8.66206 14.9339 8.70047L14.8567 8.70438H8.75027V14.8567C8.75027 15.2708 8.41436 15.6066 8.00027 15.6067C7.58606 15.6067 7.25027 15.2709 7.25027 14.8567Z"
        fill={color}
      />
    </svg>
  );
};
